import { useSelector } from "react-redux"

const RoleAccess = () => {
    const roles = useSelector((store: any) => store?.verifyLogin?.loginData?.user_data?.role)

    return roles ?? {}
}
export default RoleAccess
